import React from 'react'
import { connect } from 'react-redux'
import { bool, func } from 'prop-types'

import {
    getDesignSidepanelOpen,
    getCanPersonalize,
    getFilterModalOpen,
    getDesigningEnabled,
    getSelectedSidepanelTabs,
} from 'models/ui/selectors'
import { closeDesignSidepanel, openDesignSidepanel, openDesignLab as openDesignLabAction } from 'models/ui/actions'
import { getIsAdmin } from 'models/user/selectors'
import { sidepanelTabsType } from 'models/propTypes'

import Sidepanel from 'components/designSidepanel/Sidepanel'

const SidepanelContainer = ({
    isOpen,
    closeOptions,
    openOptions,
    showFilterModal,
    designingEnabled,
    openDesignLab,
    selectedTabs,
}) => (
    <Sidepanel
        isOpen={isOpen}
        close={closeOptions}
        open={openOptions}
        showFilterModal={showFilterModal}
        designingEnabled={designingEnabled}
        openDesignLab={openDesignLab}
        selectedTabs={selectedTabs}
    />
)

SidepanelContainer.propTypes = {
    isOpen: bool.isRequired,
    designingEnabled: bool.isRequired,
    closeOptions: func.isRequired,
    openOptions: func.isRequired,
    showFilterModal: bool.isRequired,
    openDesignLab: func.isRequired,
    selectedTabs: sidepanelTabsType.isRequired,
}

const mapStateToProps = (state) => ({
    isOpen: getDesignSidepanelOpen(state),
    canPersonalize: getCanPersonalize(state),
    isAdmin: getIsAdmin(state),
    showFilterModal: getFilterModalOpen(state),
    designingEnabled: getDesigningEnabled(state),
    selectedTabs: getSelectedSidepanelTabs(state),
})

const mapDispatchToProps = (dispatch) => ({
    closeOptions: () => dispatch(closeDesignSidepanel()),
    openOptions: () => dispatch(openDesignSidepanel()),
    openDesignLab: () => dispatch(openDesignLabAction()),
})

export default connect(mapStateToProps, mapDispatchToProps)(SidepanelContainer)
